import React from 'react';
import { useConnect } from '@lore/query-connect';
import moment from 'moment-timezone';
import Notes from '../_common_manage/Notes';

export default function EventNotes(props) {
  const { event } = props;

  const _notes = useConnect('note.find', {
    where: {
      eager: {
        $where: {
          eventId: event.id
        }
      }
    },
    pagination: {
      pageSize: 1000,
      order: 'createdAt desc'
    }
  });

  const notes = {
    ..._notes,
    data: _.sortBy(_notes.data, note => -moment(note.data.createdAt).unix())
  }

  return (
    <Notes
      notes={notes}
      label="Event notes"
      extraParams={{
        eventId: event.id
      }}
    />
  );
}
